import type { TPageTranslations } from '@crehana/i18n';

import { PAGE_KEY } from './constants';
import type { TKeys } from './types';

export const en: TPageTranslations<TKeys, typeof PAGE_KEY> = {
  [PAGE_KEY]: {
    DOWNLOAD_FILTER: 'Certification type',
    DOWNLOAD_FILTER_ALL: 'All ({{count}})',
    DOWNLOAD_FILTER_DIPLOMA: 'Certificates ({{count}})',
    DOWNLOAD_FILTER_CERTIFICATES_COURSES: 'Certificates courses ({{count}})',
    DOWNLOAD_FILTER_CERTIFICATES_TRACKS: 'Certificates tracks ({{count}})',
    DOWNLOAD_FILTER_CERTIFICATES_LIVE_SESSIONS:
      'Certificates live sessions ({{count}})',
    DOWNLOAD_FILTER_CERTIFICATES_ACCREDITATION:
      'Participation certificate ({{count}})',
    DOWNLOAD_FILTER_PROOF: 'Course proofs ({{count}})',
    DOWNLOAD_DIPLOMA: 'Certificate',
    DOWNLOAD_PROOF: 'PROOF',
    DOWNLOAD_DESCRIPTION_GENERAL:
      'In total, you have obtained {{diplomasCount}} certificates and {{certificateCount}} participation certificates',
    TYPE_CERTIFICATE: 'Certificate type',
  },
};
